
<q-page class="order-view-layout">
  <order-stepper v-if="!loading" />

  <div class="content-wrap row justify-center">
    <div class="container full-width">
      <div
        v-if="loading"
        class="preloader column justify-center items-center full-height ws-typography"
      >
        <ws-spinner class="q-mb-xl" />
        <span>
          {{ $t('general.cary_loading.top_line') }}
          <br />
          {{ $t('general.cary_loading.bottom_line') }}
        </span>
      </div>
      <router-view v-else />
    </div>
  </div>
</q-page>
